import config from 'constants/config'
import getPaymentMethods from 'lib/payment/getPaymentMethods'
import isSafari from 'lib/web/isSafari'
import isChrome from 'lib/web/isChrome'
import {
  GOOGLE_PAY_PAYMENT_TYPE,
} from 'constants/payment'

export const isGooglePayEnabled = (currency: string): boolean => !!(config.GOOGLE_PAY_ENABLED && getPaymentMethods(currency).includes(GOOGLE_PAY_PAYMENT_TYPE) && !isSafari && isChrome)
